import grid from './gridSection';
var navigation = [{
  id: 'customer-service-heading',
  title: 'Need help?',
  links: [{
    dataTest: 'footer-help-home',
    href: '/help',
    text: 'Help centre'
  }, {
    dataTest: 'footer-contact-us',
    href: '/help/contact-us',
    text: 'Contact us'
  }, {
    dataTest: 'footer-video-chat-instore',
    href: '/inspiration/video-chat-instore?gisAutoCall&tag=footer',
    text: 'Shop live with an expert'
  }, {
    dataTest: 'footer-account',
    href: '/help/account-overview',
    text: 'Account'
  }]
}, {
  id: 'delivery-and-returns-heading',
  title: 'Delivery & returns',
  links: [{
    dataTest: 'footer-delivery-collection',
    href: '/help/delivery-collection-guide',
    text: 'Delivery & collection'
  }, {
    dataTest: 'footer-returns',
    href: '/order/tracking?type=returns',
    text: 'Returns'
  }, {
    dataTest: 'footer-returns-refunds',
    href: '/help/returns-and-refunds',
    text: 'Refunds'
  }, {
    dataTest: 'footer-track-your-order',
    href: '/order/tracking',
    text: 'Track your order'
  }, {
    dataTest: 'footer-product-recall',
    href: '/help/safety-product-recalls',
    text: 'Product recall'
  }, {
    dataTest: 'footer-furniture-recycling',
    href: 'https://help.argos.co.uk/help/products-and-services/clearabee-information-page/clearabeeinfopage',
    text: 'Furniture Recycling'
  }]
}, {
  id: 'aftercare-and-finance-heading',
  title: 'Aftercare, finance & cards',
  links: [{
    dataTest: 'footer-argos-care',
    href: '/help/argos-care',
    text: 'Argos Care'
  }, {
    dataTest: 'footer-product-support',
    href: 'https://www.argos-support.co.uk/',
    text: 'Argos product support'
  }, {
    dataTest: 'footer-ways-to-pay',
    href: '/help/your-ways-to-pay',
    text: 'Ways to pay'
  }, {
    dataTest: 'footer-argos-card',
    href: '/help/argos-card',
    text: 'Argos Card'
  }, {
    dataTest: 'footer-klarna',
    href: '/help/klarna',
    text: 'Klarna'
  }, {
    dataTest: 'footer-paypal',
    href: '/help/paypal',
    text: 'PayPal'
  }]
}, {
  id: 'about-habitat-heading',
  title: 'About Habitat',
  links: [{
    dataTest: 'footer-our-heritage',
    href: '/help/our-heritage',
    text: 'Our heritage'
  }, {
    dataTest: 'footer-part-of-the-family',
    href: '/help/part-of-the-family',
    text: 'Part of the family'
  }, {
    dataTest: 'footer-careers',
    href: 'https://sainsburys.jobs',
    text: 'Careers'
  }, {
    dataTest: 'footer-press-enquiries',
    href: 'https://corporate.sainsburys.co.uk/contact-us/',
    text: 'Press enquiries'
  }, {
    dataTest: 'footer-modern-slavery-statement',
    href: 'https://corporate.sainsburys.co.uk/sustainability/explore-by-a-z/people-in-our-supply-chain/standing-up-to-modern-slavery/',
    text: 'Modern Slavery Statement'
  }]
}];
var brands = [[{
  name: 'habitat',
  dataTest: 'footer-link-img-habitat',
  linkAttributes: {
    href: '//www.habitat.co.uk/',
    target: '_blank'
  }
}, {
  name: 'sainsburys',
  dataTest: 'footer-link-img-sainsburys',
  linkAttributes: {
    href: '//www.sainsburys.co.uk/shop/gb/groceries',
    target: '_blank'
  }
}], [{
  name: 'argos',
  dataTest: 'footer-link-img-argos',
  linkAttributes: {
    href: '//www.argos.co.uk',
    target: '_blank'
  }
}, {
  name: 'tu',
  dataTest: 'footer-link-img-tu',
  linkAttributes: {
    href: '//tuclothing.sainsburys.co.uk/',
    target: '_blank'
  }
}, {
  name: 'nectar',
  dataTest: 'footer-link-img-nectar',
  linkAttributes: {
    href: '//www.nectar.com',
    target: '_blank'
  }
}]];
var legal = {
  legalText: 'Habitat is a trading name of Argos Limited who is authorised and regulated by the Financial Conduct Authority as a credit broker (713206), and works with the lender, Home Retail Group Card Services Limited trading as Argos Card and Argos Financial Services, who are authorised and regulated by the Financial Conduct Authority to provide credit (716148). Home Retail Group Card Services Limited is registered in England (04007072) at 33 Charterhouse Street, London, EC1M 6HA.',
  carePolicyText: 'Argos Care policies are provided by Domestic & General Insurance PLC, who are an insurer not an intermediary. They have not given you a personal recommendation as to whether this policy is suitable for your needs.'
};
var paypalCredit = {
  aprText: 'Representative example, provided by PayPal Credit: assumed credit limit £1,200, representative 23.9% APR (variable), purchase rate 23.9% p.a. (variable). Subject to status, terms and conditions apply.',
  legalText: 'PayPal Credit and PayPal Pay in 3 are trading names of PayPal UK ltd, 5 Fleet Place, London, United Kingdom, EC4M 7RD. Terms and conditions apply. Credit subject to status, UK residents only. Argos Limited acts as a broker and offers finance from a restricted range of finance providers. PayPal Pay in 3 is not regulated by the Financial Conduct Authority. Pay in 3 eligibility is subject to status and approval. 18+ UK residents only. Pay in 3 is an unregulated credit agreement. Check if affordable and how you will repay. May make other borrowing more difficult or expensive. See product terms for more details.'
};
var argosPayText = {
  aprText: 'PayPal Credit. Representative example. Assumed credit limit £1200, representative 23.9% APR (variable), purchase rate 23.9% APR (variable).',
  legalText: 'Argos Limited is a credit broker and not a lender, introducing Argos Pay under an exclusive arrangement with the lender NewDay Ltd. Argos Pay is provided by NewDay Ltd. UK residents aged 18 and over. Subject to status. Terms apply.'
};
var habitat = {
  navigation: navigation,
  grid: grid,
  brands: brands,
  legal: legal,
  paypalCredit: paypalCredit,
  argosPayText: argosPayText
};
export default habitat;